import {GraphPopupEntryDto, GraphTimeSpan} from '../swagger/models';
import {action, makeObservable, observable, runInAction} from 'mobx';
import {api} from '../ApiFacade';
import {showCommunicationError} from '../helpers/alerts';

export class ErrorsChartElementState {
    @observable
    showDetails: boolean = false;

    @observable
    items: GraphPopupEntryDto[] = [];

    @observable
    isLoading: boolean = false;

    key: string;
    graphTimeSpan: GraphTimeSpan;
    lastLoaded: number = 0;
    hideTimeout: any;

    constructor(key: string, graphTimeSpan: GraphTimeSpan) {
        makeObservable(this);
        this.key = key;
        this.graphTimeSpan = graphTimeSpan;
    }

    @action
    setShowDetails(v: boolean) {
        this.showDetails = v;
    }

    hideDetailsWithTimeout() {
        this.hideTimeout = setTimeout(() => {
            runInAction(() => {
                this.showDetails = false;
            });
        }, 700);
    }

    @action
    loadItems(logsIds: string[]) {
        if (this.isLoading || (this.lastLoaded > (new Date().getTime() - 10000))) {
            return;
        }

        this.isLoading = true;
        api().dashboards.apiDashboardGraphPopupGet({
            graphTimeSpan: this.graphTimeSpan,
            key: this.key,
            logsIds: logsIds,
        }).then(res => {
            this.lastLoaded = new Date().getTime();

            runInAction(() => {
                this.isLoading = false;
                this.items = res.content ?? [];
            });
        }).catch(err => {
            showCommunicationError(err);
        }).finally(() => {
            runInAction(() => {
                this.isLoading = false;
            });

        });
    }
}
